export function getGradientColorAt(position: number, isReversed = false): string {
  const stops = isReversed
    ? [
        { pos: 0, color: [235, 90, 70] },
        { pos: 0.3, color: [255, 149, 0] },
        { pos: 0.6, color: [242, 214, 0] },
        { pos: 1, color: [32, 202, 126] }
      ]
    : [
        { pos: 0, color: [32, 202, 126] },
        { pos: 0.4, color: [242, 214, 0] },
        { pos: 0.7, color: [255, 149, 0] },
        { pos: 1, color: [235, 90, 70] }
      ]

  for (let i = 0; i < stops.length - 1; i++) {
    const start = stops[i]
    const end = stops[i + 1]
    if (position >= start.pos && position <= end.pos) {
      const ratio = (position - start.pos) / (end.pos - start.pos)
      const r = Math.round(start.color[0] + (end.color[0] - start.color[0]) * ratio)
      const g = Math.round(start.color[1] + (end.color[1] - start.color[1]) * ratio)
      const b = Math.round(start.color[2] + (end.color[2] - start.color[2]) * ratio)
      return `rgb(${r}, ${g}, ${b})`
    }
  }
  return "rgb(235,90,70)"
}
